<template>
  <div class="absolute-cover pointer-events-none z-[10001]">
    <div
      v-for="(alignConf, alignment) in xAlignments"
      :key="`x-${alignment}`"
      :style="{
        left: `${alignment * scale}px`,
        top: `${alignConf.top * scale}px`,
        bottom: `${alignConf.bottom * scale}px`
      }"
      :class="[
        'absolute border-l border-[#ef46e1]',
        {
          'border-dashed': !alignConf.isSurface
        }
      ]"
    />
    <div
      v-for="(alignConf, alignment) in yAlignments"
      :key="`y-${alignment}`"
      :style="{
        top: `${alignment * scale}px`,
        left: `${alignConf.left * scale}px`,
        right: `${alignConf.right * scale}px`
      }"
      :class="[
        'absolute border-t border-[#ef46e1]',
        {
          'border-dashed': !alignConf.isSurface
        }
      ]"
    />
  </div>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const props = defineProps({
    surface: Object
  });

  const surfaceEditorStore = useSurfaceEditorStore();
  const {scale} = storeToRefs(surfaceEditorStore);

  const {xAlignments, yAlignments} = useElementPositionGuides({surface: props.surface});

</script>
